export default "__VITE_ASSET__d8609bfe__"